import HttpService from "./commons/HttpService";

const MigrateEnrollmentService = {
  searchCompany(email) {
    return HttpService.get("/migrateEnrollment/searchCompany", {
      params: { email },
    });
  },
  getMonthlyPlans(companyId) {
    return HttpService.get("/migrateEnrollment/monthlyPlans", {
      params: { companyId },
    });
  },
  getNonMonthlyOldPlans(newPlanId) {
    return HttpService.get("/migrateEnrollment/nonMonthlyOldPlans", {
      params: { newPlanId },
    });
  },
  getAllowedEnrollmentsForMigration(oldPlanId) {
    return HttpService.get(
      "/migrateEnrollment/allowedEnrollmentsForMigration",
      {
        params: { oldPlanId },
      },
    );
  },

  migrate(form) {
    return HttpService.post("/migrateEnrollment/migrate", form);
  },
};

export default MigrateEnrollmentService;
